const jivositeRemake = () => {

    if($(window).width() >= 1200) {
        let observer = new MutationObserver(mutations => {
            for(let mutation of mutations) {

                for(let node of mutation.addedNodes) {
                    // отслеживаем только узлы-элементы, другие (текстовые) пропускаем
                    if (!(node instanceof HTMLElement)) continue;

                    if (node.matches('jdiv')) {

                        const $node = $(node);
                        const $close_button = $node.find('#jivo_close_button');

                        console.log('$close_button', $close_button)

                        const $form = $node.find('#jcont');
                        const $open_button = $node.find('#jvlabelWrap');
                        const $hover_popup = $node.find('[class^=LabelButtons]');
                        const $hover_buttons = $hover_popup.find('[class^=labelButton_]');
                        let mutated = false

                        let btn_observer = new MutationObserver(btn_mutations => {
                            for(let btn of btn_mutations) {
                                if(!$(btn.target).hasClass('_init_Tk')) {
                                    $form.removeClass('hidden');
                                }
                            }
                        });

                        let hover_observer = new MutationObserver(hover_mutations => {
                            for(let item of hover_mutations) {
                                let ths = $(item.target);
                                if(!mutated) {
                                    const $facebook_btn = ths.find('[class*=labelFb_]');
                                    const $chat_btn = ths.find('[class*=chat_]');
                                    const $chat_text = $chat_btn.find('[class*=title]');

                                    if($chat_text.text() !== 'Написать в чат') {
                                        $chat_text.text('Написать в чат');
                                    }

                                    mutated = true;
                                }
                            }
                        });

                        $hover_popup.each(function () {
                            hover_observer.observe(this, {
                                attributes: true,
                                attributeFilter: ['class'],
                                childList: true,
                                characterData: true
                            });
                        });

                        $open_button.each(function () {

                            let btn_node = this;

                            $(btn_node).addClass('initial');

                            btn_observer.observe(btn_node, {
                                attributes: true,
                                attributeFilter: ['class'],
                                childList: false,
                                characterData: false
                            });

                        });

                        $form.addClass('hidden');

                        if($form.length > 0) {
                            $(document).on('click', function (e) {
                                if($(e.target).is($close_button) || $(document).find('#jivo_close_button').has(e.target).length) {

                                    console.log('close', $close_button )
                                    $(document).find('#jcont').addClass('hidden');
                                }
                            });

                            $(document).on('click', function (e) {
                                if($(e.target).is($open_button) || $(document).find('#jvlabelWrap').has(e.target).length) {
                                    console.log('open', $open_button)
                                    $(this).removeClass('initial');
                                    $form.removeClass('hidden');
                                }
                            })
                        }
                    }
                }

            }
        });

        document.querySelectorAll('body').forEach(function(node) {
            observer.observe(node, {childList: true, subtree: true, attributes: true, attributeFilter: ['class'],})
        });
    }

};

export default jivositeRemake;